const sharedBase = {
  background: 'white',
  borderStyle: 'solid',
  borderColor: 'coolGrey.10',
  borderWidth: '1px',
  borderRadius: '3px',
  boxShadow: 'none',
  'li': {
    flex: '1 1 100%',
    margin: 0,
    padding: '0.5rem 1.5rem'
  },
  'p': {
    flex: '1 1 100%',
    margin: 0,
    padding: '0.5rem 0',
    lineHeight: 'body'
  },
  'a, button': {
    flex: '1 1 100%',
    padding: '0.5rem',
    '&:hover': {
      backgroundColor: 'coolGrey.5'
    }
  },
  ['@media (max-width: 1000px)']: {
    'li, p': {
      padding: '0.5rem',
      paddingLeft: 0,
      paddingRight: 0
    },
    'a, button': {
      padding: '0.5rem',
      paddingLeft: 0,
      paddingRight: 0,
      '&:hover': {
        background: 'transparent'
      }
    }
  }
};

const base = {
  default: {
    ...sharedBase,
    top: 'calc(100% + 16px)'
  }
};

const dropdownContainer = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base
  }
};

export type DropdownContainerVariantsType = 'default';
export const dropdownContainerVariants = Object.keys(base) as DropdownContainerVariantsType[];

export default dropdownContainer;
